import { render, staticRenderFns } from "./sliber.vue?vue&type=template&id=2b57ee38&scoped=true&"
import script from "./sliber.vue?vue&type=script&lang=js&"
export * from "./sliber.vue?vue&type=script&lang=js&"
import style0 from "./sliber.vue?vue&type=style&index=0&id=2b57ee38&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b57ee38",
  null
  
)

export default component.exports